'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Run the callback while the predicate return true. Throws an
 * error if the iteration count exceeds the iteration limit.
 */
const runWhile = ({ predicate, callback, initialValue, iterationLimit = Infinity }) => {
    let counter = 0;
    let currentValue = initialValue;
    let shouldRun = predicate(currentValue);
    while (shouldRun) {
        if (counter >= iterationLimit) {
            break;
        }
        const nextValue = callback(currentValue, counter);
        counter += 1;
        shouldRun = predicate(nextValue);
        currentValue = nextValue;
    }
    return {
        result: currentValue,
        iterationCount: counter,
    };
};

exports.runWhile = runWhile;
//# sourceMappingURL=run-while.js.map
